import { defineComponent as _defineComponent } from 'vue'
import { ref, PropType } from "vue";
  import {
    InclusionInterface,
    UpdateInclusionInterface,
    inclusionDefault,
  } from "@/types/InclusionInterface";
  import InclusionDetailModal from "@/components/ui/modals/InclusionDetailModal.vue";
  import { capitalizeFirstLetter } from "./capitalizeFirstLetter";
  import AddAndUpdateInclusionModal from "@/components/ui/modals/AddAndUpdateInclusionModal.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'InclusionCard',
  props: {
    inclusion: {
      type: Object as PropType<InclusionInterface>,
      required: true,
      default: () => inclusionDefault,
    },
  },
  emits: ["updateInclusion", "delete", "openModal"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  const isDetailsModalOpen = ref(false);
  const isEditModalOpen = ref(false);
  const selectedInclusion = ref<InclusionInterface | null>(null);

  const openDetailsModal = () => {
    selectedInclusion.value = props.inclusion;
    isDetailsModalOpen.value = true;
    emits("openModal");
  };

  const closeDetailsModal = () => {
    isDetailsModalOpen.value = false;
    selectedInclusion.value = null;
  };

  const openEditModal = () => {
    selectedInclusion.value = props.inclusion;
    isEditModalOpen.value = true;
    emits("openModal");
  };

  const closeEditModal = () => {
    isEditModalOpen.value = false;
    selectedInclusion.value = null;
  };

  const deleteInclusion = () => {
    emits("delete", props.inclusion);
  };

  const updateInclusion = (data: UpdateInclusionInterface) => {
    emits("updateInclusion", data);
  };

const __returned__ = { emits, props, isDetailsModalOpen, isEditModalOpen, selectedInclusion, openDetailsModal, closeDetailsModal, openEditModal, closeEditModal, deleteInclusion, updateInclusion, ref, PropType, get InclusionInterface() { return InclusionInterface }, get UpdateInclusionInterface() { return UpdateInclusionInterface }, get inclusionDefault() { return inclusionDefault }, InclusionDetailModal, get capitalizeFirstLetter() { return capitalizeFirstLetter }, AddAndUpdateInclusionModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})